import styled from 'styled-components';
import Image from 'next/image';
import * as TypographyStyles from '../Typography/Typography.styles';

export const SliderWrapper = styled.div<{ $loading?: boolean }>`
  position: relative;
  width: 100vw;
`;

export const Slider = styled.div<{
  $photosCount?: number;
}>`
  display: grid;
  height: 330px;
  overflow-x: scroll;
  cursor: pointer;
  overflow-y: hidden;
  user-select: none;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
  -webkit-tap-highlight-color: transparent;

  &::-webkit-scrollbar {
    display: none;
  }

  grid-template-columns: repeat(${({ $photosCount }) => $photosCount}, 100%);
`;

export const Slide = styled.div`
  width: 100%;
  height: 330px;
  display: flex;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
`;

export const SlideWrapper = styled.div<{
  $photo: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-image: url(${({ $photo }) => $photo});
  background-size: cover;
  background-position: center;
  filter: blur(20px);
  transform: scale(1.1);
  z-index: 0;
  pointer-events: none;
  will-change: transform;
  contain: paint;
`;

export const SlideImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin: auto;
  position: relative;
  z-index: 2;
  user-drag: none;
`;

export const Count = styled(TypographyStyles.Typography.Caption).attrs({
  $variant: '1',
})`
  position: absolute;
  bottom: 10px;
  right: 15px;
  z-index: 1;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.overlay['40']};
  padding: 5px 15px;
  letter-spacing: -1.2px;
  color: ${({ theme }) => theme.palette.system.white};
`;
